<nz-layout class="w-full h-full bg-[#EEF0F6]">
  <!-- <img class="absolute bottom-0 left-[50%] translate-x-[-50%] translate-y-[50%]" src="../../../assets/images/corefluens/LAYOUT_LOGO.svg" alt="LAYOUT_LOGO"> -->
  <nz-sider
    class="bg-white hide-scroollbar"
    [nzTrigger]="null"
    nzCollapsible
    [(nzCollapsed)]="collapse"
    [nzWidth]="'225px'"
    (mouseenter)="collapse = false; trickyBtn.click()"
    (mouseleave)="collapse = true; closeAllCollapsibleAreas()"
    >
    <button #trickyBtn hidden></button>

    <div class="px-10 h-[100dvh] flex flex-col">
      <div class="logo pt-16 mb-31 flex" >
        <img
          [src]="collapse? '/assets/images/corefluens/Logo_Logidec.png' : '/assets/images/corefluens/LOGIDEC.png'"
          class="w-full h-32 block group-hover:hidden mx-auto max-w-[14rem]"
          alt="logidec-logo">
      </div>

      <div class="flex items-center ml-2 gap-8 mb-10 menus-title">
        <span class="min-w-6 min-h-6 bg-secondary rounded-full"></span>
        <p class="font-sans-bold text-14 whitespace-nowrap">Lógica de crédito</p>
      </div>

      <core-collapsible-menu
        [id]="collapsibleMenus[0].id"
        title="Motor de decisión"
        [isOpen]="collapsibleMenus[0].isOpen"
        (activeMenuEvent)="accordionBehavior($event)"
      >
        <fa-icon
          menu-icon
          [icon]="['fas','engine']"
          class="text-12 text-secondary ml-8 mr-2">
        </fa-icon>
        <div menu-content>
          <div class="menu-item cursor-pointer" routerLink="/inicio/motor-de-decision">
            <div class="menu-item-icon">
              <fa-icon
                [icon]="['fal','list']"
                class="text-12 ml-1"></fa-icon>
            </div>
            <p class="menu-item-text text-12 text-black">Listado de motor de decisión</p>
          </div>
          <div class="menu-item cursor-pointer" routerLink="/inicio/motor-de-decision/nuevo-motor">
            <div class="menu-item-icon">
              <fa-icon
                [icon]="['fal','plus']"
                class="text-12 ml-[0.1rem]"></fa-icon>
            </div>
            <p class="menu-item-text text-12 text-black">Nuevo motor de decisión</p>
          </div>
        </div>
      </core-collapsible-menu>
      <core-collapsible-menu
        [id]="collapsibleMenus[1].id"
        title="Análisis avanzado"
        [isOpen]="collapsibleMenus[1].isOpen"
        (activeMenuEvent)="accordionBehavior($event)"
      >
        <fa-icon
          menu-icon
          [icon]="['fas','magnifying-glass-waveform']"
          class="text-12 text-secondary ml-8 mr-2">
        </fa-icon>
        <div menu-content>
          <div class="menu-item cursor-pointer" routerLink="/inicio/analisis-de-credito">
            <div class="menu-item-icon">
              <fa-icon
                [icon]="['fal','list']"
                class="text-12 ml-1"></fa-icon>
            </div>
            <p class="menu-item-text text-12 text-black">Listado de análisis avanzado</p>
          </div>
        </div>
      </core-collapsible-menu>

      <div class="menu-item cursor-pointer mt-auto logout" (click)="logout()">
        <div class="menu-item-icon ">
          <fa-icon
            [icon]="['fal','person-from-portal']"
            class="text-16 ml-1 text-gray-7"
            ></fa-icon>
        </div>
        <p class="menu-item-text text-12 text-auth-navy-blue">Cerrar sesión</p>
      </div>

      <div class="menu-item cursor-pointer mb-10 overflow-hidden !min-h-26 !min-w-26">
        <div class="menu-item-icon bg-secondary">
          <span class="font-sans-bold text-12 text-white"> {{ userData.initial }} </span>
        </div>
        <p class="menu-item-text text-12 text-auth-navy-blue ml-7"> {{ userData.name }} </p>
      </div>
    </div>

  </nz-sider>

  <nz-layout cdkScrollable style="background: transparent;">
    <div
      cdkScrollable
      [@fadeAnimation]="outlet.isActivated ? outlet.activatedRoute : ''"
      class="max-h-screen w-full relative overflow-auto pt-25 pr-10 pl-70 xl:pl-20 lg:pr-70"
      updateOnScroll>
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </nz-layout>
</nz-layout>

<!--! Notification -->
<ng-template #templateNotification>
  <div class="ant-notification-notice-content">
    <div class="ant-notification-notice-with-icon">
      <span class="ant-notification-notice-icon">
        <fa-icon [icon]="['fas','circle-exclamation']" class="text-danger text-16"> </fa-icon>
      </span>
      <div class="ant-notification-notice-description !ml-32 !text-14">
        Si no se detecta actividad en los próximos 5 minutos su sesión terminará.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #customCloseIcon class="custom-close-icon">
  <fa-icon [icon]="['fal','xmark']" class="text-danger text-20"> </fa-icon>
</ng-template>
